import snakecaseKeys from 'snakecase-keys';
import { CosmosBaseV1Beta1Coin, IbcCoreClientV1Client, IbcApplicationsTransferV1Tx, } from '@injectivelabs/core-proto-ts';
import { MsgBase } from '../../MsgBase.js';
/**
 * @category Messages
 */
export default class MsgTransfer extends MsgBase {
    static fromJSON(params) {
        return new MsgTransfer(params);
    }
    toProto() {
        const { params } = this;
        const token = CosmosBaseV1Beta1Coin.Coin.create();
        token.denom = params.amount.denom;
        token.amount = params.amount.amount;
        const message = IbcApplicationsTransferV1Tx.MsgTransfer.create();
        message.sourcePort = params.port;
        message.sourceChannel = params.channelId;
        message.token = token;
        message.sender = params.sender;
        message.receiver = params.receiver;
        if (params.height) {
            const timeoutHeight = IbcCoreClientV1Client.Height.create();
            timeoutHeight.revisionNumber = params.height.revisionNumber.toString();
            timeoutHeight.revisionHeight = params.height.revisionHeight.toString();
            message.timeoutHeight = timeoutHeight;
        }
        if (params.timeout) {
            message.timeoutTimestamp = params.timeout.toString();
        }
        message.memo = params.memo || '';
        return IbcApplicationsTransferV1Tx.MsgTransfer.fromJSON(message);
    }
    toData() {
        const proto = this.toProto();
        return {
            '@type': '/ibc.applications.transfer.v1.MsgTransfer',
            ...proto,
        };
    }
    toAmino() {
        const proto = this.toProto();
        const message = {
            ...snakecaseKeys(proto),
        };
        return {
            type: 'cosmos-sdk/MsgTransfer',
            value: {
                ...message,
                memo: message.memo || '',
            },
        };
    }
    toWeb3Gw() {
        const amino = this.toAmino();
        const { value } = amino;
        return {
            '@type': '/ibc.applications.transfer.v1.MsgTransfer',
            ...value,
        };
    }
    toDirectSign() {
        const proto = this.toProto();
        return {
            type: '/ibc.applications.transfer.v1.MsgTransfer',
            message: proto,
        };
    }
    toBinary() {
        return IbcApplicationsTransferV1Tx.MsgTransfer.encode(this.toProto()).finish();
    }
}
